import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostFile } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const UpdateDocsFormData = createAsyncThunk(
    "updateDocsFormdata", async (arg, { rejectWithValue }) => {
        try {
            const resposnse = await doPostFile(urls.updateDocsData, arg);
            return resposnse;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const UpdateDocsFormDataSlice = createSlice({
    name: "updateDocsFormdata",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        updateDocsFormdataReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [UpdateDocsFormData.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [UpdateDocsFormData.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [UpdateDocsFormData.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})

export const { updateDocsFormdataReset } = UpdateDocsFormDataSlice?.actions;